export default {"src":"/_next/static/media/download-info-circle.4db099f0.svg","height":21,"width":21};